import React from 'react';
import {action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';

@observer
export default class CustomFieldsComponent extends React.Component {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    @action
    save1 = async (e: React.ChangeEvent<HTMLInputElement>) => {
        s.pcs.custom_text_1 = e.target.value.truncate(200, false);
    };

    @action
    save2 = async (e: React.ChangeEvent<HTMLInputElement>) => {
        s.pcs.custom_text_2 = e.target.value.truncate(200, false);
    };

    @action
    save3 = async (e: React.ChangeEvent<HTMLInputElement>) => {
        s.pcs.custom_text_3 = e.target.value.truncate(200, false);
    };

    render() {
        if (!s.ready || !s.ui.show_cust || s.prod.IsCAF) {
            return;
        }

        return (
            <div className="gray-box">
                <div>
                    <div>
                        <div>
                            {s.prod.CustomField1_Enabled && (
                                <div>
                                    <div className="b">{s.prod.CustomField1_Title}</div>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{width: 250}}
                                            onChange={this.save1}
                                            maxLength={200}
                                            aria-label={`Enter ${s.prod.CustomField1_Title}`}
                                        />
                                    </div>
                                </div>
                            )}
                            {s.prod.CustomField2_Enabled && (
                                <div className="mt-2">
                                    <div className="b">{s.prod.CustomField2_Title}</div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{width: 250}}
                                        onChange={this.save2}
                                        maxLength={200}
                                        aria-label={`Enter ${s.prod.CustomField2_Title}`}
                                    />
                                </div>
                            )}
                            {s.prod.CustomField3_Enabled && (
                                <div className="mt-2 mb-2">
                                    <div className="b">{s.prod.CustomField3_Title}</div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{width: 250}}
                                        onChange={this.save3}
                                        maxLength={200}
                                        aria-label={`Enter ${s.prod.CustomField3_Title}`}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
